import { useMemo } from 'react';
import { array, boolean, mixed, object, string } from 'yup';
import { ContactType, IContact } from '../../shared';

export function useSupplierSchema() {
    return useMemo(
        () =>
            object().shape({
                name: string().required(),
                showOnShipmentDocument: boolean().required(),
                isBatchRequired: boolean().required(),
                contacts: array()
                    .of(
                        object<IContact>().shape({
                            id: string().optional(),
                            type: mixed<ContactType>().oneOf(Object.values(ContactType)).required(),
                            data: string().required(),
                        }),
                    )
                    .optional(),
            }),
        [],
    );
}
